import { slugify } from '@/utils.js';

/**
 * Removes the mention tag and keeps the mention content only
 * @param   {string}      text The html text to be searched
 * @param   {array|null}  ids  The mentions to be stripped (if null is applied to all mentions)
 * @param   {string}      type The mention type: board, component
 * @returns {string}           The html text with the mentions stripped off
 */
export function unwrapMention(text, ids, type) {
  if (!text) return text;
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  // Select all span elements with class 'mention' and 'mention-type'
  const spanSelector = `span.mention.mention-${type}`;
  let selectors = spanSelector;
  // Also add the data-id to the selector if applicable
  if (ids) {
    selectors = [];
    ids.forEach(id => {
      selectors.push(`${spanSelector}[data-id="${id}"]`);
    });
    selectors = selectors.join();
  }
  const nodes = Array.from(doc.querySelectorAll(selectors));
  nodes.forEach(node => {
    node.replaceWith(node.innerHTML);
  });
  return doc.body.innerHTML;
}

/**
 * Set the mention content (keeps the mention tag)
 * @param   {string}  text    The html text to be searched
 * @param   {string}  id      The mention that will have the content replaced
 * @param   {string}  type    The mention type: board, component
 * @param   {string}  content The new mention content
 * @param   {string}  label   The attribute of data-label whith the original content if different
 * @returns {string}          The html text with the mentions replaced
 */
export function setMentionContent(text, id, type, content, label) {
  if (!text) return text;
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');
  // Select all span elements with class 'mention', 'mention-type' and data-id the mention id
  const selector = `span.mention.mention-${type}[data-id="${id}"]`;
  const nodes = Array.from(doc.querySelectorAll(selector));
  nodes.forEach(node => {
    node.innerHTML = content;
    if (label) {
      node.setAttribute('data-label', label);
    }
  });
  return doc.body.innerHTML;
}

/**
 * Returns the label that should be rendered based on the node type
 * @param {*} param0
 * @returns {string} The label
 */
export function renderLabel({ options: opts, node }) {
  if (node.attrs.type === 'element') {
    return slugify(node.attrs.label);
  }
  return `${node.attrs.label ?? node.attrs.id}`;
}
